import gql from 'graphql-tag'

import { CredentialsFieldsFragment } from '../credentials'
import { UserFieldsFragment } from './user'

export const CREATE_DIRECTOR_USER_MUTATION = gql`
  mutation CreateDirectorUser($user: CreateDirectorUserParams!) {
    createDirectorUser(user: $user) {
      user {
        ...UserFields
      }
      credentials {
        ...CredentialsFields
      }
    }
  }

  ${UserFieldsFragment}
  ${CredentialsFieldsFragment}
`
